export default {
  groups: [
    {
      isActive: false,
      groupId: 1,
      title: "# Submission",
      contents: [
        {
          info: 'Total number of submissions during specified time'
        }
      ]
    },
    {
      isActive: false,
      groupId: 2,
      title: "# Approvals",
      contents: [
        {
          info: "Total number of submissions that resulted in an offer during specified time"
        }
      ]
    },
    {
      isActive: false,
      groupId: 3,
      title: "$ Approved",
      contents: [
        {
          info: "Total dollar amount approved during specified time"
        }
      ]
    },
    {
      isActive: false,
      groupId: 4,
      title: "$ Funded",
      contents: [
        {
          info: "Total dollar amount funded during specified time"
        }
      ]
    },
    {
      isActive: false,
      groupId: 5,
      title: "# Funded",
      contents: [
        {
          info: "Total number of submissions that resulted in funding during specified time"
        }
      ]
    },
    {
      isActive: false,
      groupId: 6,
      title: "Average Deal Size",
      contents: [
        {
          info: "$ Funded / # Funded"
        }
      ]
    },
    {
      isActive: false,
      groupId: 7,
      title: "Auto-Decline Rate",
      contents: [
        {
          info: "% Submissions that failed to meet minimum criteria for consideration"
        }
      ]
    },
    {
      isActive: false,
      groupId: 8,
      title: "Approval Rate",
      contents: [
        {
          info: "# Submissions/ # Approvals"
        }
      ]
    },
    {
      isActive: false,
      groupId: 9,
      title: "Conversion Rate",
      contents: [
        {
          info: "# Funded / # Submissions"
        }
      ]
    },
    {
      isActive: false,
      groupId: 10,
      title: "Booking Rate",
      contents: [
        {
          info: "# Funded / # Approvals"
        }
      ]
    }
  ]
};
